/**
 * True when the event was imported from Google Calendar.
 * @param event - The event carrying optional sync metadata.
 * @returns True when a Google external id is present.
 */
export const isGoogleImportedEvent = (event: {
  sync?: { google?: { external_id?: string } };
}): boolean => Boolean(event?.sync?.google?.external_id);
